import React from "react";
import { ScrollView, StyleSheet } from "react-native";

import AboutMe from "./Attributes/AboutMe";
import InterestSelection from "./Attributes/Interest";
import LanguageSelection from "./Attributes/Languages";
import SeekingSelection from "./Attributes/Seeking";

import { type UserProfileAttributes } from "@/schemas/profile/UserProfileAttributes";
import { type AppUserSession } from "@/schemas/auth/session";
import BasicAttributes from "@/Components/PersonalAttributes/BasicAttributes";
import PhysicalAttributes from "@/Components/PersonalAttributes/PhysicalAttributes";
import { AttributeCardDisplayVariantType } from "@/Components/PersonalAttributes/types";

type EditProfileTabProps = {
  session: AppUserSession;
  attributes: UserProfileAttributes;
};

function EditAccountAttributes({
  session,
  attributes,
}: EditProfileTabProps): React.JSX.Element {
  return (
    <ScrollView style={styles.content}>
      <AboutMe session={session} aboutMeValue={attributes.aboutMe || ""} />
      <BasicAttributes
        session={session}
        attributes={attributes}
        variant={AttributeCardDisplayVariantType.ACCOUNT}
      />
      <PhysicalAttributes
        session={session}
        attributes={attributes}
        variant={AttributeCardDisplayVariantType.ACCOUNT}
      />
      <InterestSelection session={session} values={attributes.interests} />
      <SeekingSelection session={session} values={attributes.seeking} />
      <LanguageSelection session={session} values={attributes.languages} />
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  content: {
    flex: 1,
  },
});

export default EditAccountAttributes;
